import { Box } from "@material-ui/core";
import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { ParameterizationTabs } from "./parameterization/ParameterizationTabs";

// 👇 IMPORTACIONES NUEVAS PARA LA CARGA
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducers/rootReducer";
import {
  startLoadContractingOffice,
  startLoadingResponseTimesParams
} from "../../redux/actions/correspondenceActions";
import { startLoadingProcedures } from "../../module/admin/redux/actions/ProceduresActions";

export const ParameterizationAdmin = () => {

  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.auth.user);

  useEffect(() => {
    if (user?.idEntity) {
      dispatch(startLoadingProcedures(user.idEntity));
      dispatch(startLoadingResponseTimesParams(user.idEntity));
      dispatch(startLoadContractingOffice(user.idEntity));
    } else {
      console.warn("⚠️ [ADMIN] idEntity no disponible");
    }
  }, [user?.idEntity]);

  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Box>
        <ParameterizationTabs />
      </Box>
    </AppAnimate>
  );
};